"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
function Tile(_a) {
    var _b = _a.active, active = _b === void 0 ? false : _b, children = _a.children;
    return ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: {
            backgroundColor: '#fff',
            borderRadius: '5px',
            padding: '12px',
            overflow: 'hidden',
            position: 'relative',
            width: 'auto',
            border: function (theme) { return "1px solid ".concat(active ? theme.palette.primary.main : '#cdcdcd'); },
        } }, { children: children })));
}
exports.default = Tile;
